// Do not change order of this enum
/* eslint-disable perfectionist/sort-enums */
export enum AssessmentQuestionsTopic {
  relationships = 'Relationships',
  health = 'Health',
  education = 'Education',
  career = 'Career',
  service = 'Service',
  financial = 'Financial',
  spiritual = 'Spiritual',
}
